var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',{staticStyle:{"background-color":"#E5E5E5"}},[_c('v-layout',{staticStyle:{"min-height":"100vh"}},[_c('v-flex',{staticStyle:{"background-color":"#FFF"},attrs:{"shrink":""}},[_c('SideBar')],1),_c('v-flex',[_c('router-view')],1)],1),_c('Footer',{attrs:{"type":"website"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }